import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LangService {
  lang = signal('');
  setLang(lang: string) {
    this.lang.set(lang);
  }

  getLang() {
    return this.lang();
  }

  constructor() {}
}
